<script setup>
  import { titleCase } from '@/utilities';

  import { defineProps } from 'vue'
  const props = defineProps({
    typeId: String
  });
</script>
<template>
  <div :class="[
    'inline-block rounded shadow px-2 py-0',
    'bg-type-'+props.typeId
  ]">
    {{ titleCase(props.typeId) }}
  </div>
</template>
